import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/axios";
import { AxiosError } from "axios";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";
import { useNavigate, useSearchParams } from "react-router-dom";

type ResetPassword = {
  email: string;
  token: string;
  password: string;
  password_confirmation: string;
};

const resetPassword = async (form: ResetPassword) => {
  const response = await api.post("/auth/reset-password", {
    ...form,
  });
  return response.data;
};

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const emailParams = searchParams.get("email");
  const tokenParams = searchParams.get("token");
  const navigate = useNavigate();

  const [form, setForm] = useState<ResetPassword>({
    email: emailParams || "",
    token: tokenParams || "",
    password: "",
    password_confirmation: "",
  });

  const { mutate, isPending } = useMutation({
    mutationFn: resetPassword,
    onSuccess: (data) => {
      toast.success(data?.message || "Success.");
      navigate("/profile");
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>;
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      );
    },
  });

  const handleResetPassword = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    mutate(form);
  };

  return (
    <div>
      <form onSubmit={handleResetPassword} className="flex flex-col gap-y-3">
        <div>
          <Label>Password Baru</Label>
          <Input
            type="password"
            placeholder="Ketik password baru..."
            value={form.password}
            onChange={(event) =>
              setForm((prev) => ({ ...prev, password: event.target.value }))
            }
          />
        </div>
        <div>
          <Label>Konfirmasi Password Baru</Label>
          <Input
            type="password"
            placeholder="Ketik ulang password baru..."
            value={form.password_confirmation}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                password_confirmation: event.target.value,
              }))
            }
          />
        </div>
        <Button disabled={isPending}>
          {isPending ? (
            <div className="flex">
              <Loader2 className="w-4 h-4 mr-1 animate-spin" />
              Processing...
            </div>
          ) : (
            "Simpan Password Baru"
          )}
        </Button>
      </form>
    </div>
  );
}
